import { render, staticRenderFns } from "./MediaIcon.vue?vue&type=template&id=70d9fd42&scoped=true&"
import script from "./MediaIcon.vue?vue&type=script&lang=js&"
export * from "./MediaIcon.vue?vue&type=script&lang=js&"
import style0 from "./MediaIcon.vue?vue&type=style&index=0&id=70d9fd42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d9fd42",
  null
  
)

export default component.exports